import styled from "styled-components";
import { PlayCircle } from "@styled-icons/bootstrap/PlayCircle";
import { colorScheme, fonts } from "styles";
export { Button } from "styles/styled-components";

interface VideoPlayProps {
  control: boolean;
}

export const Container = styled.section`
  width: 100%;
  margin: 0 auto;
  position: relative;
  background: rgb(245, 130, 38);
  background: linear-gradient(
    135deg,
    rgba(245, 130, 38, 1) 0%,
    rgba(242, 111, 57, 1) 100%
  );
`;

export const Background = styled.div`
  width: 100%;
  height: 540px;
  background-color: ${colorScheme.secondary};
  position: absolute;
  z-index: 1;

  @media screen and (max-width: 720px) {
    display: none;
  }
`;

export const BackgroundMobile = styled.div`
  width: 100%;

  @media screen and (max-width: 720px) {
    background-color: ${colorScheme.secondary};
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 0 32px 88px 32px;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:first-child {
    padding: 88px 32px 0 32px;
  }

  @media screen and (max-width: 414px) {
    padding-bottom: 48px;

    &:first-child {
      padding-top: 48px;
    }
  }
`;

export const Title = styled.h2`
  width: 100%;
  max-width: 560px;
  font-size: 46px;
  line-height: 46px;
  margin-bottom: 32px;
  text-align: center;
  color: white;

  span {
    color: ${colorScheme.primary};

    &.dark {
      color: ${colorScheme.secondary};
    }
  }

  @media screen and (max-width: 414px) {
    font-size: 30px;
    line-height: 30px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 570px;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: white;
  margin-bottom: 80px;

  @media screen and (max-width: 414px) {
    font-size: 16px;
    margin-bottom: 32px;
  }
`;

export const VideoPlay = styled(PlayCircle)<VideoPlayProps>`
  position: absolute;
  display: ${(props) => (props.control ? "none" : "flex")};
  color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  cursor: pointer;
`;

export const Video = styled.div`
  position: relative;

  width: 100%;
  max-width: 786px;
  margin: 0 auto 80px auto;
  position: relative;
  z-index: 2;

  .player-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-top: 56.25%;
  }

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media screen and (max-width: 414px) {
    margin-bottom: 48px;
  }
`;

export const UnitsPredicted = styled.div`
  display: flex;
  width: 100%;
  max-width: 560px;
  padding: 32px 0;
  border-top: 1px #ffffff65 solid;
  border-bottom: 1px #ffffff65 solid;
  margin-bottom: 40px;

  @media screen and (max-width: 414px) {
    flex-direction: column;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px;

  @media screen and (max-width: 414px) {
    padding: 0 16px;
  }
`;

export const UnitNumber = styled.h5`
  font-family: ${fonts.BrandontextBlack};
  font-size: 54px;
  line-height: 54px;
  color: ${colorScheme.secondary};
  margin-right: 8px;

  @media screen and (max-width: 414px) {
    min-width: 100px;
  }
`;

export const Label = styled.h6`
  font-size: 14px;
  line-height: 14px;
  color: white;
  text-transform: uppercase;
`;
